import { Injectable, Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { SbTimeDateAdapter, SB_DATE_FORMATS } from '../sb-input/sb-date-adapter';
import { todayIn } from './sb-quick-picks';

/**
 * The panel calendar's adapter: weeks start on Sunday and names are English whatever the browser
 * locale (the panel's one format), and "today" is today in the field's zone. Only the panel
 * provides it; the zone is set by the panel when it opens.
 */
@Injectable()
export class SbCalendarDateAdapter extends SbTimeDateAdapter {
  zone: string | null = null;

  constructor() {
    super();
    this.setLocale('en-US');
  }

  override getFirstDayOfWeek(): number {
    return 0;
  }

  override today(): Date {
    const today = todayIn(this.zone);
    return new Date(today.year, today.month, today.day);
  }
}

export const SB_CALENDAR_ADAPTER_PROVIDERS: Provider[] = [
  { provide: DateAdapter, useClass: SbCalendarDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: SB_DATE_FORMATS },
];
